import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../../services/admin';
declare var moment: any;
declare var mdtoast: any;
var success_message = mdtoast("Opération effectué avec succès. En attante de validation par le Médecin", { duration: 5000, init: true, type: mdtoast.SUCCESS });
var error_message = mdtoast('Vous n\'avez pas accès à cette données.', { duration: 5000, init: true, type: mdtoast.ERROR });



@Component({
  selector: 'app-rappert-activiter-remb',
  templateUrl: './rappert-activiter-remb.component.html',
  styleUrls: ['./rappert-activiter-remb.component.scss']
})
export class RappertActiviterRembComponent implements OnInit {
  id: any;
  id_agent_actuel: any;
  constructor(public activatedRoute: ActivatedRoute, private router: Router, public adminService: AdminService) {
    this.id_agent_actuel = this.adminService.getUserIMIscrit();
    this.id = activatedRoute.snapshot.params['id'];
  }

  ngOnInit() {
  }

  openActivity_(id_remb: any) {
    this.router.navigate(['rapport-remb-det/' + id_remb]);
  }

  openActivitySECDAF(id_remb: any) {
    var im_sec = 408327
    if (this.id_agent_actuel == im_sec) {
      this.router.navigate(['rapport-remb-det/' + id_remb]);
    } else {
      error_message.show();
    }
  }

  openActivitySLC(id_remb: any) {
    var im_chef_slc = 351780
    var im_julie = 283635
    var im_jonhy = 292097
    var im_tina = 342782
    var im_lalao = 438285
    var im_jose = 405913
    var im_vony = 251495
    if (this.id_agent_actuel == im_chef_slc || this.id_agent_actuel == im_julie || this.id_agent_actuel == im_jonhy || this.id_agent_actuel == im_tina
      || this.id_agent_actuel == im_lalao || this.id_agent_actuel == im_jose || this.id_agent_actuel == im_vony) {
      this.router.navigate(['rapport-remb-det/' + id_remb]);
    } else {
      error_message.show();
    }

  }

  openActivityVALADMIN(id_remb: any) {
    //V Administratif
    var im_azad = 438280
    var im_kati = 438328
    var im_m_lol = 239250
    var im_m_adrien = 269139
    var im_m_claire = 322946
    if (this.id_agent_actuel == im_m_claire || this.id_agent_actuel == im_m_adrien || this.id_agent_actuel == im_azad || this.id_agent_actuel == im_kati || this.id_agent_actuel == im_m_lol) {
      this.router.navigate(['rapport-remb-det/' + id_remb]);
    } else {
      error_message.show();
    }
  }

  openActivityVALMED(id_remb: any) {
    //V Medicale
    var im_dr_laingo = 405900
    var im_dr_hary = 330027
    var im_dr_lanto = 300387
    if (this.id_agent_actuel == im_dr_laingo || this.id_agent_actuel == im_dr_hary || this.id_agent_actuel == im_dr_lanto) {
      this.router.navigate(['rapport-remb-det/' + id_remb]);
    } else {
      error_message.show();
    }
  }

  openActivityVALCHEF(id_remb: any) {
    //V Chef
    var im_chef = 322670
    var im_azad = 438280
    var im_kati = 438328
    if (this.id_agent_actuel == im_chef || this.id_agent_actuel == im_azad || this.id_agent_actuel == im_kati) {
      this.router.navigate(['rapport-remb-det/' + id_remb]);
    } else {
      error_message.show();
    }

  }

  openActivityENG(id_remb: any) {
    // Engagement
    var im_chef = 322670
    var im_chef_161 = 301400
    var im_bvy = 289179
    var im_t_haja = 269169
    var im_sitraka = 438307
    var im_mihoby = 438289
    var im_goergia = 438332
    var im_mirela = 438326
    var totos = 336140;
    if (this.id_agent_actuel == im_chef_161 || this.id_agent_actuel == im_chef
      || this.id_agent_actuel == im_t_haja || this.id_agent_actuel == im_bvy
      || this.id_agent_actuel == im_sitraka || this.id_agent_actuel == im_mihoby
      || this.id_agent_actuel == im_goergia || this.id_agent_actuel == im_mirela || this.id_agent_actuel == totos) {
      this.router.navigate(['rapport-remb-det/' + id_remb]);
    } else {
      error_message.show();
    }

  }

  openActivityORD(id_remb: any) {
    //ordonancement
    var im_chef = 322670
    var im_chef_161 = 301400
    var im_bvy = 289179
    var im_t_haja = 269169
    var im_sitraka = 438307
    var im_mihoby = 438289
    var im_goergia = 438332
    var im_mirela = 438326
    var totos = 336140;
    if (this.id_agent_actuel == im_chef_161 || this.id_agent_actuel == im_chef
      || this.id_agent_actuel == im_t_haja || this.id_agent_actuel == im_bvy
      || this.id_agent_actuel == im_sitraka || this.id_agent_actuel == im_mihoby
      || this.id_agent_actuel == im_goergia || this.id_agent_actuel == im_mirela || this.id_agent_actuel == totos) {
      this.router.navigate(['rapport-remb-det/' + id_remb]);
    } else {
      error_message.show();
    }

  }

  openActivity(id_remb: any) {
    //sec DAF
    var im_sec = 408327

    //SLC
    var im_chef_slc = 351780
    var im_julie = 283635
    var im_jonhy = 292097
    var im_tina = 342782
    var im_lalao = 438285
    var im_jose = 405913
    var im_vony = 251495


    //V Administratif
    var im_azad = 438280
    var im_kati = 438328
    var im_m_lol = 239250
    var im_m_adrien = 269139
    var im_m_claire = 322946

    //V Medicale
    var im_dr_laingo = 405900
    var im_dr_hary = 330027
    var im_dr_lanto = 300387

    //V Chef
    var im_chef = 322670

    // Engagement/ordonancement
    var im_chef_161 = 301400
    var im_bvy = 289179
    var im_t_haja = 269169
    var im_sitraka = 438307
    // var im_sitraka = "101 251 141 390";
    var im_mihoby = 438289
    var im_goergia = 438332
    var im_mirela = 438326
    var totos = 336140;

    if (id_remb == 1 && this.id_agent_actuel == im_sec) {
      this.router.navigate(['rapport-remb-det/' + id_remb]);

    } else if (this.id_agent_actuel == im_chef_slc || this.id_agent_actuel == im_chef
      || this.id_agent_actuel == im_julie || this.id_agent_actuel == im_jonhy || this.id_agent_actuel == im_tina
      || this.id_agent_actuel == im_lalao || this.id_agent_actuel == im_jose || this.id_agent_actuel == im_vony) {
      if (id_remb == 2) {
        this.router.navigate(['rapport-remb-det/' + id_remb]);
      } else {
        error_message.show();
      }

    } else if (this.id_agent_actuel == im_m_claire || this.id_agent_actuel == im_m_adrien
      || this.id_agent_actuel == im_azad || this.id_agent_actuel == im_kati || this.id_agent_actuel == im_m_lol) {
      if (id_remb == 3) {
        this.router.navigate(['rapport-remb-det/' + id_remb]);
      } else {
        error_message.show();
      }
    } else if (this.id_agent_actuel == im_dr_laingo
      || this.id_agent_actuel == im_dr_hary || this.id_agent_actuel == im_dr_lanto) {
      if (id_remb == 4) {
        this.router.navigate(['rapport-remb-det/' + id_remb]);
      } else {
        error_message.show();
      }
    } else if (id_remb == 5 && this.id_agent_actuel == im_chef || this.id_agent_actuel == im_azad || this.id_agent_actuel == im_kati) {
      this.router.navigate(['rapport-remb-det/' + id_remb]);
    }
    else if (id_remb == 8 && this.id_agent_actuel == im_chef) {
      this.router.navigate(['rapport-remb-det/' + id_remb]);
    } else if (this.id_agent_actuel == im_chef_161 || this.id_agent_actuel == im_chef
      || this.id_agent_actuel == im_t_haja || this.id_agent_actuel == im_bvy
      || this.id_agent_actuel == im_sitraka || this.id_agent_actuel == im_mihoby
      || this.id_agent_actuel == im_goergia || this.id_agent_actuel == im_mirela || this.id_agent_actuel == totos) {
      if (id_remb == 6 || id_remb == 7) {
        this.router.navigate(['rapport-remb-det/' + id_remb]);
      } else {
        error_message.show();
      }
    }
    else if (this.id_agent_actuel == im_chef_161
      || this.id_agent_actuel == im_t_haja || this.id_agent_actuel == im_bvy
      || this.id_agent_actuel == im_sitraka || this.id_agent_actuel == im_mihoby
      || this.id_agent_actuel == im_goergia || this.id_agent_actuel == im_mirela) {
      if (id_remb == 7) {
        this.router.navigate(['rapport-remb-det/' + id_remb]);
      } else {
        error_message.show();
      }
    } else {
      error_message.show();
    }
  }


  openActivity__(id_remb: any) {
    var im_sitraka = "101 251 141 390";
    var im_chef = 322670;
    var im_chef_161 = 301400.
    var totos = 336140;
    console.log(this.id_agent_actuel);
    console.log("###################");
    console.log(im_sitraka);
    if (id_remb == 6 && this.id_agent_actuel == im_chef || this.id_agent_actuel == im_chef_161 || this.id_agent_actuel == totos) {
      this.router.navigate(['rapport-remb-det/' + id_remb]);
    } else if (id_remb == 6 && this.id_agent_actuel == im_sitraka) {
      this.router.navigate(['rapport-remb-det/' + id_remb]);
    } else {
      error_message.show();
    }
  }


}
